// DeclinedItemsList — struck-through list of the procedures a patient
// turned down (treatment_plan_items with status 'Declined'). Shared by
// the Declined proposal view and the partially-accepted view. Renders
// nothing when there are no declined items.

function formatPHP(centavos) {
  if (!Number.isFinite(centavos)) return "—";
  return `₱${Math.round(centavos / 100).toLocaleString()}`;
}
function itemLine(it) {
  const proc = it.procedure_name || "Procedure";
  const tooth = it.tooth_number ? `#${it.tooth_number}` : "";
  const surface = it.surface ? ` ${it.surface}` : "";
  return [proc, tooth, surface].filter(Boolean).join(" ").trim();
}

export default function DeclinedItemsList({ items = [] }) {
  const declined = items.filter((it) => it.status === "Declined");
  if (declined.length === 0) return null;
  return (
    <ul data-testid="declined-items" className="space-y-2">
      {declined.map((it) => (
        <li
          key={it.id}
          data-testid={`declined-item-${it.id}`}
          className="flex items-center justify-between gap-3 border border-dashed border-slate-200 rounded-lg px-3 py-2.5 opacity-70"
        >
          <span className="text-sm text-slate-500 line-through">{itemLine(it)}</span>
          <span className="text-xs text-slate-400 line-through tabular-nums">{formatPHP(Number(it.fee_centavos) || 0)}</span>
        </li>
      ))}
    </ul>
  );
}
